(() => {
  const connectBtn = document.getElementById('wallet-connect-btn');
  const signBtn = document.getElementById('wallet-sign-btn');
  const statusLabel = document.getElementById('wallet-status-label');
  const addressEl = document.getElementById('wallet-address');
  const signatureWrap = document.getElementById('signature-wrap');
  const verifiedEl = document.getElementById('wallet-verified');
  const purchaseOptionsLink = document.getElementById('purchase-options-link');
  const purchaseOptionsSection = document.querySelector('[data-token-gate-purchase-section]');

  if (!connectBtn || !signBtn || !statusLabel || !addressEl || !signatureWrap || !verifiedEl) return;

  const signMessage = `Redeem token - verify wallet ownership\n\nSite: ${window.location.hostname}\nTimestamp: ${new Date().toISOString()}`;
  const redemptionStorageKey = `token_redemption_confirmed:${window.location.pathname}`;

  function shortenAddress(address) {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }

  function setConnected(address) {
    statusLabel.textContent = `Wallet connected: ${shortenAddress(address)}`;
    addressEl.textContent = address;
    addressEl.hidden = false;
    signatureWrap.hidden = false;
    verifiedEl.hidden = true;
    connectBtn.textContent = 'Disconnect';
    connectBtn.setAttribute('aria-label', 'Disconnect wallet');

    if (isRedemptionConfirmed(address)) {
      setRedeemed(address);
    }
  }

  function hidePurchaseOptions() {
    document.documentElement.removeAttribute('data-token-redemption-confirmed');

    if (purchaseOptionsLink) {
      purchaseOptionsLink.hidden = true;
    }

    if (purchaseOptionsSection) {
      purchaseOptionsSection.hidden = true;
      purchaseOptionsSection.setAttribute('inert', '');
    }
  }

  function revealPurchaseOptions(scrollToOptions = false) {
    document.documentElement.setAttribute('data-token-redemption-confirmed', 'true');

    if (purchaseOptionsLink) {
      purchaseOptionsLink.hidden = false;
    }

    if (!purchaseOptionsSection) return;

    purchaseOptionsSection.hidden = false;
    purchaseOptionsSection.removeAttribute('inert');

    if (scrollToOptions) {
      window.requestAnimationFrame(() => {
        purchaseOptionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function resetUI() {
    statusLabel.textContent = 'No wallet connected';
    addressEl.hidden = true;
    addressEl.textContent = '';
    signatureWrap.hidden = true;
    verifiedEl.hidden = true;
    connectBtn.textContent = 'Connect wallet';
    connectBtn.removeAttribute('aria-label');
    connectBtn.disabled = false;
    signBtn.disabled = false;
    signBtn.textContent = 'Sign & redeem token';
    hidePurchaseOptions();
  }

  function isRedemptionConfirmed(address) {
    try {
      return Boolean(window.sessionStorage && window.sessionStorage.getItem(`${redemptionStorageKey}:${address.toLowerCase()}`));
    } catch (_error) {
      return false;
    }
  }

  function rememberRedemption(address) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(`${redemptionStorageKey}:${address.toLowerCase()}`, 'true');
      }
    } catch (_error) {
      // Storage is only used to preserve the confirmation message across wallet events.
    }
  }

  function setRedeemed(address, scrollToOptions = false) {
    rememberRedemption(address);
    statusLabel.textContent = `Token redemption confirmed for ${shortenAddress(address)}.`;
    signatureWrap.hidden = true;
    verifiedEl.hidden = false;
    verifiedEl.querySelector('span').textContent = 'Token redemption confirmed. Your wallet has been linked to this token.';
    signBtn.disabled = true;
    signBtn.textContent = 'Token redeemed';
    revealPurchaseOptions(scrollToOptions);
  }

  async function connectWallet() {
    if (!window.ethereum) {
      window.alert('No Web3 wallet detected. Please install MetaMask or another EVM-compatible wallet extension.');
      return;
    }

    if (!addressEl.hidden) {
      resetUI();
      return;
    }

    connectBtn.disabled = true;
    connectBtn.textContent = 'Connecting...';

    try {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      if (accounts && accounts.length > 0) {
        setConnected(accounts[0]);
      } else {
        throw new Error('No accounts returned.');
      }
    } catch (error) {
      window.alert(error && error.code === 4001 ? 'Connection cancelled.' : 'Could not connect wallet. Please try again.');
      resetUI();
    } finally {
      connectBtn.disabled = false;
    }
  }

  async function signWalletMessage() {
    const address = addressEl.textContent.trim();
    if (!address) return;

    signBtn.disabled = true;
    signBtn.textContent = 'Awaiting signature...';

    try {
      await window.ethereum.request({
        method: 'personal_sign',
        params: [signMessage, address]
      });

      setRedeemed(address, true);
    } catch (error) {
      window.alert(error && error.code === 4001 ? 'Signature cancelled.' : 'Could not complete signing. Please try again.');
      signBtn.disabled = false;
      signBtn.textContent = 'Sign & redeem token';
    }
  }

  if (window.ethereum) {
    window.ethereum.on('accountsChanged', (accounts) => {
      resetUI();
      if (accounts && accounts.length > 0) {
        setConnected(accounts[0]);
      }
    });
  }

  connectBtn.addEventListener('click', connectWallet);
  signBtn.addEventListener('click', signWalletMessage);
  if (purchaseOptionsLink && purchaseOptionsSection) {
    purchaseOptionsLink.addEventListener('click', (event) => {
      event.preventDefault();
      revealPurchaseOptions(true);
    });
  }
})();
